// 活动统一分享配置：路由守卫按 meta.share 自动写入
const activityShare = {
  link: location.origin + import.meta.env.BASE_URL + 'wanren-wenchuang',
  title: '科普中国万份文创免费送，手慢无！',
  desc: '每月登录科普中国客户端或邀请10位好友注册登录，即可免费领取文创礼品',
  img: '',
  isShareImage: 0,
};

const routes = [
  {
    path: '/wanren-wenchuang',
    name: 'wanren-wenchuang',
    component: () => import('@/views/wanren-wenchuang/HomeView.vue'),
    meta: {
      title: '科普中国万份文创免费送，手慢无！',
      share: activityShare,
    },
  },
  {
    path: '/wanren-wenchuang/invite-poster',
    name: 'wanren-wenchuang-invite-poster',
    component: () => import('@/views/wanren-wenchuang/InvitePosterView.vue'),
    meta: {
      title: '科普中国万份文创免费送，手慢无！',
      share: activityShare,
    },
  },
  {
    path: '/wanren-wenchuang/invite-verify',
    name: 'wanren-wenchuang-invite-verify',
    component: () => import('@/views/wanren-wenchuang/InviteVerifyView.vue'),
    meta: {
      title: '科普中国万份文创免费送，手慢无！',
      share: activityShare,
    },
  },
  {
    path: '/wanren-wenchuang/download',
    name: 'wanren-wenchuang-download',
    component: () => import('@/views/wanren-wenchuang/DownloadView.vue'),
    meta: {
      title: '科普中国万份文创免费送，手慢无！',
      share: activityShare,
    },
  },
  {
    path: '/wanren-wenchuang/exchange-record',
    name: 'wanren-wenchuang-exchange-record',
    component: () => import('@/views/wanren-wenchuang/ExchangeRecordView.vue'),
    meta: {
      title: '兑换记录',
      share: activityShare,
    },
  },
  {
    path: '/wanren-wenchuang/rule',
    name: 'wanren-wenchuang-rule',
    component: () => import('@/views/wanren-wenchuang/RuleView.vue'),
    meta: {
      title: '活动规则',
      share: activityShare,
    },
  },
];
export default routes;
